import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { useSegment } from 'utils/hooks';
import { ReactComponent as CopyIcon } from 'assets/img/icons/copy.svg';

export default function Copy({ value = '' }) {
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);

  const { track } = useSegment();

  useEffect(() => {
    if (copiedToClipboard) {
      const timer = setTimeout(() => setCopiedToClipboard(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [copiedToClipboard]);

  const onCopy = () => {
    track('Copied to clipboard', { value });
    navigator.clipboard.writeText(value).then(() => setCopiedToClipboard(true));
  };

  return (
    <UiKit.Flex align="center" gap={8}>
      <UiKit.Text size="md">{value}</UiKit.Text>
      <UiKit.Tooltip>
        <UiKit.Tooltip.Trigger>
          <UiKit.Button variant="ghost" size="sm" className="p-0">
            <CopyIcon className={styles.icon} onClick={onCopy} />
          </UiKit.Button>
        </UiKit.Tooltip.Trigger>
        <UiKit.Tooltip.Content>
          {copiedToClipboard ? 'Copied!' : 'Copy'}
        </UiKit.Tooltip.Content>
      </UiKit.Tooltip>
    </UiKit.Flex>
  );
}
